<script setup lang="ts">
// ================================
// IMPORTS
// ================================
import { useI18n } from "vue-i18n"

// ================================
// INTERNATIONALIZATION
// ================================
const { t } = useI18n({
    messages: {
        fr: {
            title: "Informations générales de la station météo",
        },
    },
})

// ================================
// TYPES & INTERFACES
// ================================
interface Props {
    /**
     * Identifiant du capteur
     */
    sourceId: string
}

// ================================
// PROPS & EMITS
// ================================
defineProps<Props>()
</script>

<template>
    <div class="weather-station-info-wrapper flex flex-col gap-16">
        <!-- ================================ -->
        <!-- EN-TÊTE -->
        <!-- ================================ -->
        <HeaderPageSource
            :title="t('title')"
            :source-id="sourceId"
            icon="pi pi-info-circle"
            class-header="flex items-center justify-between"
        />

        <!-- ================================ -->
        <!-- CONTENU - MODE LECTURE -->
        <!-- ================================ -->
        <WeatherStationDisplay :source-id="sourceId" />
    </div>
</template>
